import { render, staticRenderFns } from "./trainAdminCreationCompetitionTwo.vue?vue&type=template&id=b816baa8&scoped=true"
import script from "./trainAdminCreationCompetitionTwo.vue?vue&type=script&lang=js"
export * from "./trainAdminCreationCompetitionTwo.vue?vue&type=script&lang=js"
import style0 from "./trainAdminCreationCompetitionTwo.vue?vue&type=style&index=0&id=b816baa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b816baa8",
  null
  
)

export default component.exports